export { default } from './VpBudgetErrorDialog';



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpBudgetErrorDialog/index.js